<template>
  <BaseInnerLoading />
</template>

<script setup lang="ts">
import { ApiError } from "@/api"

const router = useRouter()
const token = useRouteQuery<string>("token")

onMounted(async () => {
  if (token.value) {
    try {
      await logInMagicLink(token.value)
      router.push({ name: "dashboard" })
    } catch (error) {
      router.push({ name: "login" })
      logError(error)
      if (error instanceof ApiError) {
        if (error.code === "token-expired") {
          toast.error(
            "Failed to log in. Access link has expired",
            3000
          )
        } else {
          toast.error("Failed to log in")
        }
      }
    }
  } else {
    router.push({ name: "login" })
  }
})
</script>
